import { render, staticRenderFns } from "./DeviceForm.vue?vue&type=template&id=4710fcf8&"
import script from "./DeviceForm.vue?vue&type=script&lang=js&"
export * from "./DeviceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports